import React, { useState } from 'react';
import { authApi } from '../api/authApi';
import { Alert, Button, Card, CardBody, CardHeader, Field, Input } from './ui';

const getErr = (err, fallback) => err?.response?.data?.message || err?.message || fallback;
const MIN_LENGTH = 8;

const ChangePassword = ({ onSuccess }) => {
  const [form, setForm] = useState({ old_password: '', new_password: '', confirm_password: '' });
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const setField = (key) => (e) => {
    setForm((current) => ({ ...current, [key]: e.target.value }));
    if (error) setError('');
    if (success) setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    const { old_password, new_password, confirm_password } = form;

    if (!old_password || !new_password || !confirm_password) return setError('All fields are required.');
    if (new_password.length < MIN_LENGTH) return setError(`New password must be at least ${MIN_LENGTH} characters.`);
    if (new_password === old_password) return setError('New password must be different from your current one.');
    if (new_password !== confirm_password) return setError('New password and confirm password do not match.');

    setLoading(true);
    try {
      const res = await authApi.updatePassword(form);
      setSuccess(res?.message || 'Password updated successfully.');
      setForm({ old_password: '', new_password: '', confirm_password: '' });
      onSuccess?.(res);
    } catch (err) {
      setError(getErr(err, 'Could not update password. Please try again.'));
    } finally {
      setLoading(false);
    }
  };

  const inputType = show ? 'text' : 'password';

  return (
    <Card>
      <form onSubmit={handleSubmit}>
        <CardHeader title="Change Password" />
        <CardBody className="flex flex-col gap-4">
          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="success">{success}</Alert>}
          <Field label="Current Password"><Input type={inputType} value={form.old_password} onChange={setField('old_password')} autoComplete="current-password" /></Field>
          <div className="grid gap-4 md:grid-cols-2">
            <Field label="New Password"><Input type={inputType} value={form.new_password} onChange={setField('new_password')} autoComplete="new-password" /></Field>
            <Field label="Confirm New Password"><Input type={inputType} value={form.confirm_password} onChange={setField('confirm_password')} autoComplete="new-password" /></Field>
          </div>
          <label className="flex cursor-pointer items-center gap-2 font-dm text-[13px] text-giggs-text">
            <input className="h-4 w-4 accent-giggs-green" type="checkbox" checked={show} onChange={() => setShow((current) => !current)} />
            Show passwords
          </label>
          <div className="flex justify-end border-t border-slate-100 pt-4"><Button type="submit" disabled={loading}>{loading ? 'Updating…' : 'Update Password'}</Button></div>
        </CardBody>
      </form>
    </Card>
  );
};

export default ChangePassword;
